<template>
    <div class="panel panel-default">
        <div class="inspection-tab-white">
            <div id="inspection-internal">
                <div class="row internal-elements" v-for="inspection_internal in inspection_internals">
                    <div class="col-lg-6">
                        <h2 class="title">{{ inspection_internal.element.section.name }} - {{ inspection_internal.element.name }}</h2>
                        <div class="image">
                            <div class="image-points">
                                <img :src="`${ inspection_internal.element.image_path }`" class="chair">
                                <div v-for="point in inspection_internal.points"
                                     :style="`left: ${ point.x }px;top: ${ point.y }px`" class="internal-point">
                                    {{ point.order }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 internal-element-data">
                        <div v-if="inspection_internal.photo.url != null" class="title-photo">
                            <h3>Общая фотография секции - {{ inspection_internal.element.section.name }}</h3>
                            <button class="btn btn-primary" v-on:click="inspection_internal.photo.display = !inspection_internal.photo.display">Смотреть фото</button>
                            <div v-if="inspection_internal.photo.display" class="inspection-photo">
                                <a :href="inspection_internal.photo.url" target="_blank">
                                    <img :src="inspection_internal.photo.url">
                                </a>
                            </div>
                        </div>
                        <div v-else class="row"></div>
                        <div class="internal-element-data-table">
                            <h3>Повреждения</h3>
                            <table class="table table-striped">
                                <tbody>
                                <tr v-for="point in inspection_internal.points">
                                    <td>{{ point.order }}</td>
                                    <td>
                                        <div v-for="damage in point.damages">
                                            {{ damage.name }}
                                        </div>
                                    </td>
                                    <td>
                                        <button class="btn btn-sm btn-edit" v-on:click="point.photo.display = !point.photo.display">Смотреть фото</button>
                                        <div v-if="point.photo.display" class="inspection-photo">
                                            <a :href="point.photo.url" target="_blank">
                                                <img :src="point.photo.url">
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import _ from 'lodash'

    export default {
        name: 'InspectionInternal',
        props: [
            'inspection_id',
            'photo_default'
        ],
        asyncComputed: {
            inspection_internals() {
                return axios
                    .get('/api/inspections/' + this.inspection_id + '/internal', {
                        params: {}
                    })
                    .then(({data}) => {
                        for (var i in data) {
                            if (data[i].photo==null) {
                                data[i].photo={'display':false};
                            } else {
                                data[i].photo.display = false;
                            }
                            for (var k in data[i].points) {
                                if (data[i].points[k].photo==null) {
                                    data[i].points[k].photo={'display':false};
                                } else {
                                    data[i].points[k].photo.display = false;
                                }
                            }
                        }
                        return data
                    })
            },
        },
        methods: {}
    }
</script>


// WEBPACK FOOTER //
// InspectionInternal.vue?070f6838